export default __webpack_public_path__ + "static/media/weather_app_image.660f4c18.png";